import React, { useEffect, useState } from "react";
import {
  IPrepareIndividualData,
  NotificationActions,
} from "../../../../../slices/NotificationSlice";
import { NotifyEffExpDate } from "../components/NotifyEffExpDate";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux-store/store";
import {
  GetAllNotification_M3,
  PublishNotification,
} from "../../../../../api/notifyapi/Notifyapi";
import { Spin } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { ETableRowActionFieldApplicable } from "../../../notificationPage/NotificationMangement";

interface IExpiryDateProps {
  data: IPrepareIndividualData | null;
  renderStatusStyle: () => string;
  onClose: () => void;
  onCloseViewPopup: () => void;
  checkExpiry: any;
}

const ExpirayDateComponent: React.FC<IExpiryDateProps> = (props) => {
  // Initial state from props data
  const [effectiveDate, setEffectiveDate] = useState<string>(
    props.data?.effectiveDate || ""
  );
  const [expiryDate, setExpiryDate] = useState<string>(
    props.data?.expiryDate || ""
  );
  const [validEffStartDate, setValidEffStartDate] = useState<Dayjs>(
    dayjs().subtract(1, "day")
  );
  const [validExpStartDate, setValidExpStartDate] = useState<Dayjs>(dayjs());
  const [isEffDateValid, setEffDateValid] = useState<boolean>(false);
  const [isExpDateValid, setExpDateValid] = useState<boolean>(false);

  const { apiQuery } = useSelector(
    (state: RootState) => state.notification.searchFilter
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let lEffDate = "";
    if (props.data?.effectiveDate) {
      lEffDate = props.data?.effectiveDate;
    }
    setEffectiveDate(lEffDate);
  }, [props.data?.effectiveDate]);

  useEffect(() => {
    let lExpDate = "";
    if (props.data?.expiryDate) {
      lExpDate = props.data?.expiryDate;
    }
    setExpiryDate(lExpDate);
  }, [props.data?.expiryDate]);

  const handleGoBack = () => {
    props.onClose();
  };

  const handleEffDateEdit = (date: Dayjs | null) => {
    let lDate = "";
    if (date) {
      lDate = date.format("YYYY-MM-DDTHH:mm:ss");

      setValidExpStartDate(date.add(1, "day"));
    }
    setEffectiveDate(lDate);
  };

  const handleExpDateEdit = (date: Dayjs | null) => {
    let lDate = "";
    if (date) {
      lDate = date.format("YYYY-MM-DDTHH:mm:ss");
    }
    setExpiryDate(lDate);
  };

  const handleToPublish = () => {
    try {      
      if (props.data) {
        setIsLoading(true);
        dispatch(
          PublishNotification({
            effectiveDate: effectiveDate,
            expiryDate: expiryDate,
            notificationIDs: [props.data.notificationID],
            performedBy: props.data.assignedUser[0],
            state: "PUBLISHED",
          })
        ).then(() => {
          setIsLoading(false);
          dispatch(NotificationActions.UpdateViewPopup(false));
          dispatch(GetAllNotification_M3(apiQuery));
        });
      }
    } catch (error) {}
  };

  const getPulishbtnState = (): ETableRowActionFieldApplicable => {
    if (isEffDateValid || isExpDateValid) {
      return ETableRowActionFieldApplicable.Blur;
    }
    if (!isEffDateValid || !isExpDateValid) {
      return ETableRowActionFieldApplicable.Show;
    }
    return ETableRowActionFieldApplicable.Blur;
  };

  useEffect(() => {}, [])
  return (
    <div>
      <div className="view-modal-body">
        <div className="view-notification-heading-element">
          Publishing Details
        </div>
        <div className="expiry-date-div">
          <div>
            <div className="label-element">Notification Title</div>
            <span className="view-modal-value-element">
              {props.data?.title}
            </span>
          </div>
          <div>
            <div className="label-element">Effective Date</div>
            <span className="view-modal-value-element">
              <NotifyEffExpDate
                date={effectiveDate}
                displayEditOpt={true}
                field="effective"
                errorMessage="Effective date has passed. Please edit to publish."
                validStartDateToEdit={validEffStartDate}
                onEditDated={handleEffDateEdit}
                isValidDate={isEffDateValid}
                onValidCheck={(valid) => {
                  setEffDateValid(valid);
                }}
              />
            </span>
          </div>
          <div>
            <div className="label-element">Expiry Date</div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div>
                <span style={{ paddingTop: "3px" }}>
                  <NotifyEffExpDate
                    date={expiryDate}
                    displayEditOpt={true}
                    field="expiry"
                    errorMessage="Expiry date has passed. Please edit to publish."
                    validStartDateToEdit={validExpStartDate}
                    onEditDated={handleExpDateEdit}
                    isValidDate={isExpDateValid}
                    onValidCheck={(valid) => {
                      setExpDateValid(valid);
                    }}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="view-modal-footer">
        <button
          disabled={
            getPulishbtnState() === ETableRowActionFieldApplicable.Blur
              ? true
              : false
          }
          className={`popup-create-btn ${
            getPulishbtnState() === ETableRowActionFieldApplicable.Blur
              ? " disabled-button-style"
              : ""
          }`}
          onClick={() =>handleToPublish()} >
          Publish
          {isLoading ? (
            <Spin
              size="small"
              spinning={isLoading}
              style={{ marginLeft: "8px" }}
            />
          ) : (
            <></>
          )}
        </button>
        <button className="popup-create-btn outline-btn" onClick={handleGoBack}>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default ExpirayDateComponent;
